export default {
  Months: {
    geo: [
      "იანვარი",
      "თებერვალი",
      "მარტი",
      "აპრილი",
      "მაისი",
      "ივნისი",
      "ივლისი",
      "აგვისტო",
      "სექტემბერი",
      "ოქტომბერი",
      "ნოემბერი",
      "დეკემბერი",
    ],
    geoShort: [
      "იან",
      "თებ",
      "მარტ",
      "აპრ",
      "მაი",
      "ივნ",
      "ივლ",
      "აგვ",
      "სექ",
      "ოქტ",
      "ნოე",
      "დეკ",
    ],
    eng: [
      "January",
      "February",
      "Match",
      "Aprile",
      "May",
      "June",
      "Jule",
      "August",
      "Secetember",
      "Octomber",
      "November",
      "December",
    ],
  },
  WeekDays: {
    geo: [
      "ორშაბათი",
      "სამშაბათი",
      "ოთხშაბათი",
      "ხუთშაბათი",
      "პარასკევი",
      "შაბათი",
      "კვირა",
    ],
    geoShort: [
      "ორშ",
      "სამშ",
      "ოთხშ",
      "ხუთშ",
      "პარ",
      "შაბ",
      "კვ",
    ],
    geoAbbrev: [
        "ორშ",
        "სამშ",
        "ოთხშ",
        "ხუთშ",
        "პარ",
        "შაბ",
        "კვ",
      ],
  },
};
